var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("h4", [
          _vm._v(" " + _vm._s(_vm.lead.ref_id) + " - Send a follow up SMS")
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row mb-4" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("Send to")]),
                _vm._v(" "),
                _c("p", { staticClass: "form-control" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.customer_phone_selected
                          ? _vm.phoneMask.maskedPhone(
                              _vm.customer_phone_selected
                            )
                          : "No phone added"
                      ) +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col pl-1" }, [
              _c(
                "div",
                { staticClass: "select-wrap" },
                [
                  _c("label", [_vm._v("Phone")]),
                  _vm._v(" "),
                  _vm.contacts.length > 0
                    ? _c("simple-select", {
                        attrs: {
                          options: _vm.contacts,
                          label: "maskedPhone",
                          "return-value": "phone",
                          placeholder: "Select Phone"
                        },
                        on: { input: _vm.getMessages },
                        model: {
                          value: _vm.customer_phone_selected,
                          callback: function($$v) {
                            _vm.customer_phone_selected = $$v
                          },
                          expression: "customer_phone_selected"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row mb-4 scrollable scrollableModal" },
            [
              _vm.thread.data
                ? _vm._l(_vm.thread.data, function(message) {
                    return _c(
                      "div",
                      { key: message.id, staticClass: "col-12" },
                      [
                        message.direction === 2
                          ? [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-9 bg-primary rounded" },
                                  [
                                    _c("p", { staticClass: "m-1 text-white" }, [
                                      _vm._v(_vm._s(message.body))
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3" })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("small", { staticClass: "m-1" }, [
                                    _vm._v(_vm._s(message.date))
                                  ])
                                ])
                              ])
                            ]
                          : [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-3" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-9 bg-light rounded" },
                                  [
                                    _c("p", { staticClass: "m-1" }, [
                                      _vm._v(_vm._s(message.body))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col text-right" }, [
                                  _c("small", { staticClass: "m-1" }, [
                                    _vm._v(_vm._s(message.date))
                                  ])
                                ])
                              ])
                            ]
                      ],
                      2
                    )
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-10 pr-0" }, [
              _c("div", { staticClass: "select-wrap h-auto" }, [
                _c("label", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.list ? _vm.lead.company : _vm.lead.company.name
                      ) +
                      "\n              " +
                      _vm._s(
                        _vm.phoneMask.maskedPhone(_vm.company_phone_selected)
                      ) +
                      ":\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { attrs: { contenteditable: "true" } }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newMessage,
                        expression: "newMessage"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.sending },
                    domProps: { value: _vm.newMessage },
                    on: {
                      keypress: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.sendFollowUpSMS($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.newMessage = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 pl-0" }, [
              _c(
                "button",
                {
                  staticClass: "pt-2 w-100 btn btn-primary ld-ext-right",
                  class: _vm.loadingButton ? "running" : "",
                  attrs: {
                    type: "button",
                    disabled: !_vm.newMessage || _vm.sending
                  },
                  on: { click: _vm.sendFollowUpSMS }
                },
                [
                  _c("span", { staticClass: "mod-icon-note" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ld ld-ball ld-flip" })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 mt-2" },
              [
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "message_limit" }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36102119", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36102119","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/followUps/SMS.vue
// module id = null
// module chunks = 